import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import {
  FaReact,
  FaJsSquare,
  FaPython,
  FaNodeJs,
  FaGitAlt,
  FaFigma
} from 'react-icons/fa';
import {
  SiTypescript,
  SiTailwindcss,
  SiMongodb,
  SiPostgresql,
  SiNextdotjs,
  SiExpress,
  SiCplusplus,
  SiMysql
} from 'react-icons/si';
import './About.css';

const About = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const skills = [
    { name: 'JavaScript', icon: FaJsSquare, color: '#F7DF1E' },
    { name: 'React', icon: FaReact, color: '#61DAFB' },
    { name: 'Node.js', icon: FaNodeJs, color: '#339933' },
    { name: 'Python', icon: FaPython, color: '#3776AB' },
    { name: 'C++', icon: SiCplusplus, color: '#00599C' },
    { name: 'HTML/CSS', icon: FaReact, color: '#E34F26' },
    { name: 'MongoDB', icon: SiMongodb, color: '#47A248' },
    { name: 'MySQL', icon: SiMysql, color: '#4479A1' },
    { name: 'Express', icon: SiExpress, color: '#000000' },
    { name: 'Next.js', icon: SiNextdotjs, color: '#000000' },
    { name: 'Git', icon: FaGitAlt, color: '#F05032' },
    { name: 'Figma', icon: FaFigma, color: '#F24E1E' },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut',
      },
    },
  };

  const skillVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.5,
        ease: 'easeOut',
      },
    },
  };

  return (
    <section id="about" className="about section">
      <div className="container">
        <motion.div
          ref={ref}
          variants={containerVariants}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
        >
          <motion.h2 className="section-title" variants={itemVariants}>
            About Me
          </motion.h2>

          <div className="about-content">
            <motion.div className="about-text" variants={itemVariants}>
              <motion.p variants={itemVariants}>
                Hi, I’m Gayatri, a Computer Engineering student and software developer who enjoys building meaningful digital experiences and solving real-world problems through code.
              </motion.p>

              <motion.p variants={itemVariants}>
                I focus on full-stack web development using modern JavaScript frameworks, with a keen eye for user experience. I love learning new technologies and guiding others along the way.              </motion.p>

              <motion.p variants={itemVariants}>
                I enjoy building reliable solutions with attention to detail and usability. I’m always open to learning, experimenting, and working with people who love creating impactful technology.              </motion.p>


            </motion.div>

            <motion.div className="about-skills" variants={itemVariants}>
              <h3>Technologies & Tools</h3>
              <div className="skills-grid">
                {skills.map((skill, index) => (
                  <motion.div
                    key={skill.name}
                    className="skill-item"
                    variants={skillVariants}
                    whileHover={{
                      scale: 1.1,
                      y: -5,
                      transition: { duration: 0.2 }
                    }}
                    custom={index}
                  >
                    <skill.icon
                      className="skill-icon"
                      style={{ color: skill.color }}
                    />
                    <span className="skill-name">{skill.name}</span>
                  </motion.div>
                ))}
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;